export default () => {
  window.addEventListener('load', () => {

    document.getElementById('app-main').style.paddingBottom =
      document.getElementById('app-footer').clientHeight + 'px'

  })

  document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.getElementsByClassName('nav-link')).forEach(el => {
      if (el.className.indexOf("nav-store-config") >= 0) {
        el.addEventListener('click', (e) => {
          Array.from(document.getElementsByClassName('nav-sub-store-config')).forEach(els => {
            if (els.style.display === "none") els.style.display = "block"
            else els.style.display = "none"
          })
        })
      }
      if (el.className.indexOf("nav-report") >= 0) {
        el.addEventListener('click', (e) => {
          Array.from(document.getElementsByClassName('nav-sub-report')).forEach(els => {
            if (els.style.display === "none") els.style.display = "block"
            else els.style.display = "none"
          })
        })
      }
      if (el.className.indexOf("nav-complaints") >= 0) {
        el.addEventListener('click', (e) => {
          Array.from(document.getElementsByClassName('nav-sub-complaints')).forEach(els => {
            if (els.style.display === "none") els.style.display = "block"
            else els.style.display = "none"
          })
        })
      }
      if (el.className.indexOf("nav-services") >= 0) {
        el.addEventListener('click', (e) => {
          Array.from(document.getElementsByClassName('nav-sub-services')).forEach(els => {
            if (els.style.display === "none") els.style.display = "block"
            else els.style.display = "none"
          })
        })
      }
      if (el.className.indexOf("nav-operations") >= 0) {
        el.addEventListener('click', (e) => {
          Array.from(document.getElementsByClassName('nav-sub-operations')).forEach(els => {
            if (els.style.display === "none") els.style.display = "block"
            else els.style.display = "none"
          })
        })
      }
    })
  })
}
